export type FilterRow =
  | { field: string; op: "=" | "!="; value: string | number | boolean }
  | { field: string; op: "IN" | "NOT IN"; value: (string | number | boolean)[] }
  | { field: string; op: ">=" | "<=" | ">" | "<"; value: number | string }
  | { field: string; op: "BETWEEN"; value: [number | string, number | string] };

// Helper function to correctly format a value for a Meilisearch filter
const formatValue = (value: any): string => {
  if (typeof value === 'string') {
    return `'${value.replace(/'/g, "\\'")}'`;
  }
  return value;
};

export function toMeiliFilter(rows: FilterRow[] = []): string[] {
  const clauses: string[] = [];

  for (const r of rows) {
    if (r.value === '' || r.value === null || r.value === undefined) {
      continue;
    }

    // FIX #2: Correctly formats the IN and NOT IN operators
    if (r.op === "IN" || r.op === "NOT IN") {
      const arr = r.value as (string | number | boolean)[];
      if (!arr?.length) continue;
      const formattedValues = arr.map(formatValue).join(", ");
      clauses.push(`${r.field} ${r.op} [${formattedValues}]`);

    } else if (r.op === "BETWEEN") {
      const [a, b] = r.value as [number | string, number | string];
      clauses.push(`${r.field} ${formatValue(a)} TO ${formatValue(b)}`);
      
    } else {
      clauses.push(`${r.field} ${r.op} ${formatValue(r.value)}`);
    }
  }
  return clauses;
}